import { Box, Container, Typography, Grid } from '@mui/material';
import { motion } from 'framer-motion';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ContactForm from '../../components/ContactForm';
import CTAButton from '../../components/CTAButton';
import SEO from '../../components/SEO';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const HiringMaids = () => {
  return (
    <>
      <SEO 
        title="Hire Professional Maids in Kampala | Vetted Domestic Staff Uganda"
        description="Hire trusted, background-checked maids in Kampala. Professional domestic staff for homes & offices. Trained & insured cleaners. Flexible schedules available. Call 0752 058 190"
        keywords="hire maids Kampala, domestic workers Uganda, house help Kampala, professional maids Uganda, vetted domestic staff, housekeeping services Kampala"
        url="https://blossomcleaningservices.com/services/hiring-maids"
      />
      <Header />

      <Box sx={{ position: 'relative', py: 12, backgroundImage: 'url(https://images.unsplash.com/photo-1581578731350-86e0c7562913?w=1920&q=80)', backgroundSize: 'cover', backgroundPosition: 'center', '&::before': { content: '""', position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(34, 51, 95, 0.75)' } }}>
        <Container sx={{ position: 'relative', zIndex: 1 }}>
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
            <Typography variant="h1" sx={{ mb: 3, color: 'white', fontSize: { xs: '2.5rem', md: '3.5rem' } }}>
              Hiring Maids
            </Typography>
            <Typography variant="h5" sx={{ maxWidth: 800, color: 'rgba(255,255,255,0.95)', mb: 4 }}>
              Thoroughly vetted, trained, and trustworthy domestic staff for your home
            </Typography>
            <CTAButton to="/contact">Hire Now</CTAButton>
          </motion.div>
        </Container>
      </Box>

      <Box sx={{ py: 8 }}>
        <Container>
          <Grid container spacing={6}>
            <Grid item xs={12} md={8}>
              <Typography variant="h3" sx={{ mb: 4, fontWeight: 600 }}>
                Professional Domestic Staff You Can Trust
              </Typography>
              <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
                Finding trustworthy domestic help can be challenging. At Blossom Cleaning, we take the stress out of hiring by providing thoroughly vetted, trained, and insured maids who deliver exceptional service.
              </Typography>
              <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.8 }}>
                All our staff undergo comprehensive background checks, professional training, and continuous supervision. We match you with the right person based on your specific needs and preferences.
              </Typography>
              
              <Typography variant="h4" sx={{ mb: 3, fontWeight: 600 }}>
                Our Vetting Process
              </Typography>
              <Grid container spacing={2}>
                {['Background verification', 'Reference checks', 'Skills assessment', 'Professional training', 'Health screening', 'Ongoing supervision'].map((item, index) => (
                  <Grid item xs={12} sm={6} key={index}>
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                      <CheckCircleIcon sx={{ color: 'primary.main', fontSize: 20 }} />
                      <Typography variant="body2">{item}</Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Box sx={{ py: 8, backgroundColor: 'background.paper' }}>
        <Container maxWidth="md">
          <ContactForm title="Request Domestic Staff" showServiceSelect={false} />
        </Container>
      </Box>

      <Footer />
    </>
  );
};

export default HiringMaids;
